module.exports = __webpack_public_path__ + "static/img/10.b99629f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/10.png
// module id = a8kB
// module chunks = 0